import { render } from "./TrainingSkillSuggestionComponent.vue?vue&type=template&id=ddd983fc&scoped=true"
import script from "./TrainingSkillSuggestionComponent.vue?vue&type=script&lang=js"
export * from "./TrainingSkillSuggestionComponent.vue?vue&type=script&lang=js"

import "./TrainingSkillSuggestionComponent.vue?vue&type=style&index=0&id=ddd983fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd983fc"]])

export default __exports__